"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CetusGateway = void 0;
exports.getAlphaPrice = getAlphaPrice;
exports.getBlubPrice = getBlubPrice;
const tslib_1 = require("tslib");
const cetus_sui_clmm_sdk_1 = require("@cetusprotocol/cetus-sui-clmm-sdk");
const bn_js_1 = tslib_1.__importDefault(require("bn.js"));
const mainnet_config_js_1 = require("./cetus/mainnet_config.js");
const simpleCache_js_1 = require("./protocol/simpleCache.js");
const index_js_1 = require("./pyth/index.js");
const alphafi_sdk_1 = require("@alphafi/alphafi-sdk");
const poolData = {
    "SUI/WUSDC": {
        pair: "SUI/WUSDC",
        id: "0xcf994611fd4c48e277ce3ffd4d4364c914af2c3cbb05f7bf6facd371de688630",
        a2b: false,
    },
    "WUSDC/SUI": {
        pair: "WUSDC/SUI",
        id: "0xcf994611fd4c48e277ce3ffd4d4364c914af2c3cbb05f7bf6facd371de688630",
        a2b: true,
    },
    "SUI/USDT": {
        pair: "SUI/USDT",
        id: "0x06d8af9e6afd27262db436f0d37b304a041f710c3ea1fa4c3a9bab36b3569ad3",
        a2b: false,
    },
    "USDT/SUI": {
        pair: "USDT/SUI",
        id: "0x06d8af9e6afd27262db436f0d37b304a041f710c3ea1fa4c3a9bab36b3569ad3",
        a2b: true,
    },
    "WUSDC/USDT": {
        pair: "WUSDC/USDT",
        id: "0xc8d7a1503dc2f9f5b05449a87d8733593e2f0f3e7bffd90541252782e4d2ca20",
        a2b: false,
    },
    "USDT/WUSDC": {
        pair: "USDT/WUSDC",
        id: "0xc8d7a1503dc2f9f5b05449a87d8733593e2f0f3e7bffd90541252782e4d2ca20",
        a2b: true,
    },
    "SUI/VSUI": {
        pair: "SUI/VSUI",
        id: "0x6c545e78638c8c1db7a48b282bb8ca79da107993fcb185f75cedc1f5adb2f535",
        a2b: false,
    },
    "VSUI/SUI": {
        pair: "VSUI/SUI",
        id: "0x6c545e78638c8c1db7a48b282bb8ca79da107993fcb185f75cedc1f5adb2f535",
        a2b: true,
    },
    "SUI/NAVX": {
        pair: "SUI/NAVX",
        id: "0x0254747f5ca059a1972cd7f6016485d51392a3fde608107b93bbaebea550f703",
        a2b: false,
    },
    "NAVX/SUI": {
        pair: "NAVX/SUI",
        id: "0x0254747f5ca059a1972cd7f6016485d51392a3fde608107b93bbaebea550f703",
        a2b: true,
    },
    "ALPHA/SUI": {
        pair: "ALPHA/SUI",
        id: "0xda7347c3192a27ddac32e659c9d9cbed6f8c9d1344e605c71c8886d7b787d720",
        a2b: true,
    },
    "SUI/ALPHA": {
        pair: "ALPHA/SUI",
        id: "0xda7347c3192a27ddac32e659c9d9cbed6f8c9d1344e605c71c8886d7b787d720",
        a2b: false,
    },
    // "USDY/USDC": {
    //   pair: "USDY/USDC",
    //   id: "0x0e809689d04d87f4bd4e660cd1b84bf5448c5a7997e3d22fc480e7e5e0b3f58d",
    //   a2b: true,
    // },
    // "USDC/USDY": {
    //   pair: "USDY/USDC",
    //   id: "0x0e809689d04d87f4bd4e660cd1b84bf5448c5a7997e3d22fc480e7e5e0b3f58d",
    //   a2b: false,
    // },
    "BUCK/WUSDC": {
        pair: "BUCK/WUSDC",
        id: "0x81fe26939ed676dd766358a60445341a06cea407ca6f3671ef30f162c84126d5",
        a2b: true,
    },
    "WUSDC/BUCK": {
        pair: "WUSDC/BUCK",
        id: "0x81fe26939ed676dd766358a60445341a06cea407ca6f3671ef30f162c84126d5",
        a2b: false,
    },
    "WSOL/WUSDC": {
        pair: "WSOL/WUSDC",
        id: "0x9ddb0d269d1049caf7c872846cc6d9152618d1d3ce994fae84c1c051ee23b179",
        a2b: true,
    },
    "WUSDC/WSOL": {
        pair: "WUSDC/WSOL",
        id: "0x9ddb0d269d1049caf7c872846cc6d9152618d1d3ce994fae84c1c051ee23b179",
        a2b: false,
    },
    "SUI/USDC": {
        pair: "SUI/USDC",
        id: "0xb8d7d9e66a60c239e7a60110efcf8de6c705580ed924d0dde141f4a0e2c90105",
        a2b: false,
    },
    "USDC/SUI": {
        pair: "USDC/SUI",
        id: "0xb8d7d9e66a60c239e7a60110efcf8de6c705580ed924d0dde141f4a0e2c90105",
        a2b: true,
    },
};
async function getAlphaPrice(ignoreCache) {
    let alphaPrice = 0;
    const res = await getCetusSwapQuoteForBillionCoins(alphafi_sdk_1.coinsList.ALPHA, alphafi_sdk_1.coinsList.SUI);
    const latestSuiPrice = await (0, index_js_1.getLatestPrices)(["SUI/USD"], ignoreCache);
    alphaPrice =
        res.estimatedAmountOut.toNumber() * Number(latestSuiPrice) * 1e-9;
    return alphaPrice;
}
async function getCetusSwapQuoteForBillionCoins(coinA, coinB) {
    const cetusGateway = new CetusGateway(mainnet_config_js_1.cetusMainnetSDKOptions);
    const swapOption = {
        pair: { coinA: coinA, coinB: coinB },
        senderAddress: "0x4260738f0f7341adc79a8edaa62f8a4681ebd27c595aecab1f322f47bfc52c5e",
        slippage: 1,
        inAmount: new bn_js_1.default(1000000000),
    };
    const res = await cetusGateway.getPrice(swapOption);
    return res;
}
// export async function getUSDYPrice(
//   ignoreCache: boolean,
// ): Promise<number | undefined> {
//   const cetusGateway = new CetusGateway(cetusMainnetSDKOptions);
//   const swapOption: CetusSwapOptions = {
//     pair: { coinA: coins.USDY, coinB: coins.USDC },
//     senderAddress:
//       "0x4260738f0f7341adc79a8edaa62f8a4681ebd27c595aecab1f322f47bfc52c5e",
//     slippage: 1,
//     inAmount: new BN(1_000_000),
//   };
//   const res = await cetusGateway.getPrice(swapOption);
//   const latestSuiPrice = await getLatestPrices(["USDC/USD"], ignoreCache);
//   if (latestSuiPrice) {
//     return res.estimatedAmountOut.toNumber() * Number(latestSuiPrice) * 1e-6;
//   }
// }
async function getBlubPrice() {
    //TO-DO --> retruning 1 since blub not in use
    return 1;
    // const hopGateway = new HopGateway(hopSDKOptions);
    // const swapOptions: HopSwapOptions = {
    //   pair: { coinA: coins.BLUB, coinB: coins.WUSDC },
    //   senderAddress:
    //     "0x4260738f0f7341adc79a8edaa62f8a4681ebd27c595aecab1f322f47bfc52c5e",
    //   inAmount: new BN(1_000_000_000),
    //   slippage: 1,
    // };
    // const res = await hopGateway.getQuote(swapOptions);
    // const latestUSDCPrice = await getLatestPrices(["USDC/USD"], ignoreCache);
    // if (latestUSDCPrice) {
    //   return (
    //     Number(res.amount_out_with_fee) * Number(latestUSDCPrice) * 1e-6 * 1e-7
    //   );
    // }
}
const priceCache = new simpleCache_js_1.SimpleCache(5000);
const pricePromiseCache = new simpleCache_js_1.SimpleCache(5000);
class CetusGateway {
    constructor(sdkOptions) {
        this.cetusSDK = new cetus_sui_clmm_sdk_1.CetusClmmSDK(sdkOptions);
        this.cetusSDK.senderAddress = sdkOptions.simulationAccount.address;
    }
    async getPools(pairs) {
        const allPools = await this.cetusSDK.Pool.getPoolsWithPage([]);
        const matchedPools = [];
        pairs.forEach((pair) => {
            const filteredPools = allPools.filter((pool) => {
                if (pair.coinA && pair.coinB) {
                    return ((pool.coinTypeA === pair.coinA.type &&
                        pool.coinTypeB === pair.coinB.type) ||
                        (pool.coinTypeA === pair.coinB.type &&
                            pool.coinTypeB === pair.coinA.type));
                }
                else if (pair.coinA && !pair.coinB) {
                    return (pool.coinTypeA === pair.coinA.type ||
                        pool.coinTypeB === pair.coinA.type);
                }
                else if (!pair.coinA && pair.coinB) {
                    return (pool.coinTypeB === pair.coinB.type ||
                        pool.coinTypeB === pair.coinB.type);
                }
            });
            matchedPools.push(...filteredPools);
        });
        console.log(matchedPools);
        console.log(`Matched pools for specified pairs: ${matchedPools.length}`);
        console.log(`Total pools: ${allPools.length}`);
        return matchedPools;
    }
    async getPrice(options, ignoreCache) {
        const { pair, inAmount, outAmount } = options;
        const cacheKey = `price_${pair.coinA.name}_${pair.coinB.name}`;
        const poolDatum = poolData[pair.coinA.name + "/" + pair.coinB.name];
        if (ignoreCache) {
            priceCache.delete(cacheKey);
            pricePromiseCache.delete(cacheKey);
        }
        // Check if the pool is already in the cache
        const cachedPrice = priceCache.get(cacheKey);
        if (cachedPrice) {
            return cachedPrice;
        }
        let pricePromise = pricePromiseCache.get(cacheKey);
        if (pricePromise) {
            return pricePromise;
        }
        // If not, create a new promise and cache it
        pricePromise = (async () => {
            try {
                let amount = new bn_js_1.default(0);
                let byAmountIn = true;
                if (inAmount) {
                    byAmountIn = true;
                    amount = inAmount;
                }
                else if (outAmount) {
                    byAmountIn = false;
                    amount = outAmount;
                }
                const pool = await this.cetusSDK.Pool.getPool(poolDatum.id, ignoreCache);
                const swapTicks = await this.cetusSDK.Pool.fetchTicks({
                    pool_id: pool.poolAddress,
                    coinTypeA: pool.coinTypeA,
                    coinTypeB: pool.coinTypeB,
                });
                const res = this.cetusSDK.Swap.calculateRates({
                    decimalsA: pair.coinA.expo,
                    decimalsB: pair.coinB.expo,
                    a2b: poolDatum.a2b,
                    byAmountIn,
                    amount,
                    swapTicks,
                    currentPool: pool,
                });
                priceCache.set(cacheKey, res);
                return res;
            }
            catch (e) {
                console.error(`Error in getPrice; ${pair.coinA.name}, ${pair.coinB.name}, ${inAmount}, ${outAmount}`);
                return {
                    estimatedAmountOut: new bn_js_1.default(0),
                    estimatedAmountIn: new bn_js_1.default(0),
                    estimatedEndSqrtPrice: new bn_js_1.default(0),
                    estimatedFeeAmount: new bn_js_1.default(0),
                    isExceed: false,
                    extraComputeLimit: 0,
                    aToB: true,
                    byAmountIn: false,
                    amount: new bn_js_1.default(0),
                    priceImpactPct: 0,
                };
            }
            finally {
                // Remove the promise from the cache after it resolves
                pricePromiseCache.delete(cacheKey);
            }
        })();
        // Cache the promise
        pricePromiseCache.set(cacheKey, pricePromise);
        return pricePromise;
    }
    async getTransaction(options) {
        const res = await this.getPrice(options);
        const { pair, senderAddress, slippage, inAmount, outAmount } = options;
        const poolDatum = poolData[pair.coinA.name + "/" + pair.coinB.name];
        const poolID = poolDatum.id;
        const pool = await this.cetusSDK.Pool.getPool(poolID);
        let byAmountIn = true;
        if (inAmount) {
            byAmountIn = true;
        }
        else if (outAmount) {
            byAmountIn = false;
        }
        const slippagePercentage = new cetus_sui_clmm_sdk_1.Percentage(new bn_js_1.default(Math.floor(slippage * 100).toString()), new bn_js_1.default(100));
        const toAmount = byAmountIn
            ? res.estimatedAmountOut
            : res.estimatedAmountIn;
        const amountLimit = (0, cetus_sui_clmm_sdk_1.adjustForSlippage)(toAmount, slippagePercentage, !byAmountIn);
        // TransactionBlock
        this.cetusSDK.senderAddress = senderAddress;
        const txb = this.cetusSDK.Swap.createSwapTransactionPayload({
            pool_id: pool.poolAddress,
            coinTypeA: pool.coinTypeA,
            coinTypeB: pool.coinTypeB,
            a2b: poolDatum.a2b,
            by_amount_in: byAmountIn,
            amount: res.amount.toString(),
            amount_limit: amountLimit.toString(),
        });
        return txb;
    }
    async createPoolTransactionBlock(options) {
        console.log((0, cetus_sui_clmm_sdk_1.d)(options.initializePrice), alphafi_sdk_1.coinsList[options.coinNameA].expo, alphafi_sdk_1.coinsList[options.coinNameB].expo);
        const initializeSqrtPrice = cetus_sui_clmm_sdk_1.TickMath.priceToSqrtPriceX64((0, cetus_sui_clmm_sdk_1.d)(options.initializePrice), alphafi_sdk_1.coinsList[options.coinNameA].expo, alphafi_sdk_1.coinsList[options.coinNameB].expo).toString();
        const current_tick_index = cetus_sui_clmm_sdk_1.TickMath.sqrtPriceX64ToTickIndex(new bn_js_1.default(Math.floor(parseFloat(initializeSqrtPrice)).toString()));
        // build tick range
        const lowerTick = cetus_sui_clmm_sdk_1.TickMath.getPrevInitializableTickIndex(new bn_js_1.default(Math.floor(current_tick_index).toString()).toNumber(), new bn_js_1.default(options.tickSpacing.toString()).toNumber());
        const upperTick = cetus_sui_clmm_sdk_1.TickMath.getNextInitializableTickIndex(new bn_js_1.default(Math.floor(current_tick_index).toString()).toNumber(), new bn_js_1.default(options.tickSpacing.toString()).toNumber());
        // slippage value 0.05 means 5%
        const slippage = 0.01;
        // Estimate liquidity and token amount from one amounts
        const liquidityInput = cetus_sui_clmm_sdk_1.ClmmPoolUtil.estLiquidityAndcoinAmountFromOneAmounts(lowerTick, upperTick, new bn_js_1.default(options.amount.toString()), options.isAmountA, true, slippage, new bn_js_1.default(initializeSqrtPrice.toString()));
        // Estimate  token a and token b amount
        const amount_a = options.isAmountA
            ? options.amount
            : liquidityInput.tokenMaxA.toNumber();
        const amount_b = options.isAmountA
            ? liquidityInput.tokenMaxB.toNumber()
            : options.amount;
        console.log({
            coinTypeA: alphafi_sdk_1.coinsList[options.coinNameA].type,
            coinTypeB: alphafi_sdk_1.coinsList[options.coinNameB].type,
            tick_spacing: options.tickSpacing,
            initialize_sqrt_price: `${initializeSqrtPrice}`,
            uri: options.imageUrl,
            amount_a: amount_a,
            amount_b: amount_b,
            fix_amount_a: options.isAmountA,
            tick_lower: lowerTick,
            tick_upper: upperTick,
        });
        // const paramss: CreatePoolParams = {
        //   tick_spacing: 60,
        //   initialize_sqrt_price: TickMath.priceToSqrtPriceX64(
        //     d(2.36528),
        //     9,
        //     6,
        //   ).toString(),
        //   uri: "",
        //   coinTypeA:
        //     "0xfe3afec26c59e874f3c1d60b8203cb3852d2bb2aa415df9548b8d688e6683f93::alpha::ALPHA",
        //   coinTypeB:
        //     "0x5d4b302506645c37ff133b98c4b50a5ae14841659738d6d733d59d0d217a93bf::coin::COIN",
        // };
        // const txb = this.cetusSDK.Pool.creatPoolTransactionPayload(paramss);
        // build creatPoolPayload Payload
        const txb = this.cetusSDK.Pool.creatPoolTransactionPayload({
            coinTypeA: alphafi_sdk_1.coinsList[options.coinNameA].type,
            coinTypeB: alphafi_sdk_1.coinsList[options.coinNameB].type,
            tick_spacing: options.tickSpacing,
            initialize_sqrt_price: `${initializeSqrtPrice}`,
            uri: options.imageUrl,
            // amount_a: amount_a,
            // amount_b: amount_b,
            // fix_amount_a: options.isAmountA,
            // tick_lower: lowerTick,
            // tick_upper: upperTick,
        });
        return txb;
    }
}
exports.CetusGateway = CetusGateway;
//# sourceMappingURL=cetus.js.map